<template>
  <div>
    <app-input-form
      v-bind:parentObject="{
        data: this.formData,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:save="saveHandler"
    />
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>

import CaseSubjectMaintenanceForm from "../../../components/industrialrelations/casesubjectmaintenance/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-input-form": CaseSubjectMaintenanceForm,
    "app-error": ErrorDialog,
  },

  data() {
    return {
      pageTitle: this.$t('ircasemaintenance.staffcasemaintenance'), 
      pageTitleValue: "",
      formData: {
        ircaseid: null,
        casesubdetail: [],
        stamp: 0,
        userid: this.$store.getters.userId,
      },

      errMsg: "",
      isErr: false,
      editMode: false,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    saveHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        return false;
      }

      this.$store.dispatch('post', {url: "/casesubmaintenance/create", payload: vm.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "casesubmaintenancelist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    cancelHandler() {
      this.$router.push({ name: "casesubmaintenancelist" });
    },
  },
};
</script>